// In index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n/config';
import reportWebVitals from './reportWebVitals';

window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation();
  }
});

// Completely patch the ResizeObserver
const patchResizeObserver = () => {
  const OriginalResizeObserver = window.ResizeObserver;

  // Save original console error
  const originalConsoleError = console.error;

  // Override console.error
  console.error = (...args) => {
    // Don't log ResizeObserver errors
    if (args[0] && typeof args[0] === 'string' && args[0].includes('ResizeObserver')) {
      return;
    }
    return originalConsoleError.apply(console, args);
  };

  // Create patched version
  window.ResizeObserver = class PatchedResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch (e) {
            // Silently catch the error
            if (e.message.includes('ResizeObserver')) {
              console.warn('[Suppressed] ResizeObserver error');
            } else {
              throw e;
            }
          }
        });
      });
    }
  };

  // Patch error event handler too
  window.addEventListener(
    'error',
    (event) => {
      if (event.message?.includes('ResizeObserver') || event.error?.message?.includes('ResizeObserver')) {
        event.stopImmediatePropagation();
        event.preventDefault();
        return true;
      }
    },
    true,
  );

  // Patch unhandled rejection too
  window.addEventListener(
    'unhandledrejection',
    (event) => {
      if (event.reason?.message?.includes('ResizeObserver')) {
        event.stopImmediatePropagation();
        event.preventDefault();
        return true;
      }
    },
    true,
  );
};

// Apply the patch before anything renders
patchResizeObserver();

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(<App />);

reportWebVitals();
